import React from "react";
import PropTypes from "prop-types";

const NUM_OF_INDICATORS_TO_SHOW = 3;

const SampleReportGridIndicatorsList = ({ data }) => {
  return (
    <ul className="sample-report-grid__list sample-report-grid__list--indicators">
      {Array(NUM_OF_INDICATORS_TO_SHOW)
        .fill()
        .map((item, idx) => {
          return <li key={idx}>{data[idx] || "--"}</li>;
        })}
    </ul>
  );
};

SampleReportGridIndicatorsList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string)
};

export default SampleReportGridIndicatorsList;
